import * as Schema from 'generated/graphql/schema';
import { Cctv, VideoInputAntenna } from 'mdi-material-ui';
import React from 'react';

import * as Types from '@/types';

export const CAMERA_ICON = Cctv;
export const EVENT_ICON = VideoInputAntenna;

export const getNodeIcon = (className: string, type: Schema.NodeType): React.ReactNode => {
  switch (type) {
    case Schema.NodeType.Main:
      return <img src={'/images/bottleneck.svg'} className={className} />;
    case Schema.NodeType.Counter:
      return <img src={'/images/counter.svg'} className={className} />;
    case Schema.NodeType.Scrap:
      return <img src={'/images/scrap.svg'} className={className} />;
    case Schema.NodeType.Camera:
      return <img src={'/images/camera.svg'} className={className} />;
    case Schema.NodeType.Event:
      return <img src={'/images/event.svg'} className={className} />;
    default:
      Types.assertUnreachable(type);
      return <img src={'/images/counter.svg'} className={className} />;
  }
};

export const getNodeRingIconPath = (type: Schema.NodeType, highlighted: boolean = false): string => {
  const ICON_PATH = '/images/';
  switch (type) {
    case Schema.NodeType.Main:
      return highlighted ? `${ICON_PATH}bottleneck_ring_highlight.svg` : `${ICON_PATH}bottleneck_ring.svg`;
    case Schema.NodeType.Counter:
      return highlighted ? `${ICON_PATH}counter_ring_highlight.svg` : `${ICON_PATH}counter_ring.svg`;
    case Schema.NodeType.Scrap:
      return highlighted ? `${ICON_PATH}scrap_ring_highlight.svg` : `${ICON_PATH}scrap_ring.svg`;
    case Schema.NodeType.Camera:
      return highlighted ? `${ICON_PATH}camera_ring_highlight.svg` : `${ICON_PATH}camera_ring.svg`;
    case Schema.NodeType.Event:
      return highlighted ? `${ICON_PATH}event_ring_highlight.svg` : `${ICON_PATH}event_ring.svg`;
    default:
      Types.assertUnreachable(type);
      return highlighted ? `${ICON_PATH}counter_ring_highlight.svg` : `${ICON_PATH}counter_ring.svg`;
  }
};
